import { Form } from 'react-bootstrap'
import { Text, TextArea, SelectBox, DatePicker, Number, Email, File } from '../../../input_fields'
import { FormikProvider, useFormik } from 'formik'
import { SaveButton } from '../../../buttons'
import { UpdateProfileSchema } from './ValidationSchema'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Loader } from '../../../loader'
import { debounce } from 'lodash'
import { districtList } from '../../../../redux/slices/master'
import { updateProfile } from '../../../../redux/slices/users'
import { addUpdateHandler } from '../../../../utils'
import { toggleUpdateModal, toggleBool } from '../../../../redux/slices/globalSlice'
import { useTranslation } from 'react-i18next'

export const ProfileImport = {
    Form,
    Text,
    TextArea,
    SelectBox,
    DatePicker,
    Number,
    Email,
    File,
    FormikProvider,
    useFormik,
    SaveButton,
    UpdateProfileSchema,
    useNavigate,
    Loader,
    debounce,
    useSelector,
    useDispatch,
    districtList,
    updateProfile,
    addUpdateHandler,
    toggleUpdateModal,
    toggleBool,
    useTranslation
}